export default __webpack_public_path__ + "static/media/entertainment.ecb53306.svg";